import { createColumnHelper } from "@tanstack/react-table";

export const getCellStyles = (key, originalRow) => {
  if (key && originalRow) {
    return {
      backgroundColor: originalRow[key]?.bg_color ?? "",
      color: originalRow[key]?.txt_color ?? "",
    };
  }
  return {};
};

export const safeNumberConversion = (value) => {
  // Handle string numbers (including those with currency symbols)
  if (typeof value === "string") {
    // Remove currency symbols and other non-numeric characters except decimal point
    const cleanedValue = value.replace(/[^0-9.-]/g, "");
    const parsed = parseFloat(cleanedValue);
    return isNaN(parsed) ? 0 : parsed;
  }
  // Handle direct numbers
  if (typeof value === "number") {
    return isNaN(value) ? 0 : value;
  }
  // Handle null, undefined, or other types
  return 0;
};

export const columnHelper = createColumnHelper();

export const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => {
      // The result includes the data URI prefix (e.g., "data:image/jpeg;base64,...")
      const base64String = reader.result;
      resolve(base64String);
    };

    reader.onerror = (error) => {
      reject(error);
    };

    reader.readAsDataURL(file);
  });
};

export const formatValue = (value, type, columnInfo) => {
  if (value === undefined || value === null) return "";

  const processedValue = (() => {
    switch (type) {
      case "float":
      case "currency": {
        // First convert to number and fix to 2 decimal places
        const numValue = Number(value).toFixed(2);

        // Split the number into integer and decimal parts
        const [integerPart, decimalPart] = numValue.split(".");

        // Format the integer part with space as thousands separator
        const formattedInteger = integerPart.replace(
          /\B(?=(\d{3})+(?!\d))/g,
          " "
        );

        // Combine the parts back with a decimal point
        return `${formattedInteger}.${decimalPart}`;
      }
      case "int":
      case "integer": {
        // Format integer with space as thousands separator
        return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, " ");
      }
      default:
        return value;
    }
  })();

  const prefix = columnInfo?.prefix ? `${columnInfo.prefix} ` : "";
  const suffix = columnInfo?.append ? ` ${columnInfo.append}` : "";

  return `${prefix}${processedValue}${suffix}`;
};
